import { Fragment, useEffect, useState } from "react";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";
import { i18n, initializeI18n } from "../localization/i18n";
import { translate } from "../localization/translateService";

// "New to DOTORE? Start here" — heading + 3 quick-access cards (icon + title + subtitle + arrow).
// Localization: title/subtitle/goals = CMS props (Umbraco variant). When CMS empty -> i18n
// translate() defaults (NOT hardcoded English). Default goal links below are fixed routes.
const GOAL_LINKS = ["/pretest", "/contact-us?tab=CUSTOMER_CENTER", "/courses?page=1&rows=12&sortBy=newest"];

// Default icons — Iconsax Bold, exact Figma colors (used when a goal has no CMS icon media)
// 0 Take Level Test = award/medal (orange), 1 Enrollment & Manual = edit (cyan), 2 Class Guide = profile-2user (yellow)
const DEFAULT_ICONS = [
  <svg key="m" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M42.5005 36.94L39.2005 37.72C38.4605 37.9 37.8805 38.46 37.7205 39.2L37.0205 42.14C36.6405 43.74 34.6005 44.24 33.5405 42.98L27.5605 36.1C27.0805 35.54 27.3405 34.66 28.0605 34.48C31.6005 33.62 34.7805 31.64 37.1205 28.82C37.5005 28.36 38.1805 28.3 38.6005 28.72L43.0405 33.16C44.5605 34.68 44.0205 36.58 42.5005 36.94Z" fill="#FBA935" />
    <path d="M5.40033 36.94L8.70033 37.72C9.44033 37.9 10.0203 38.46 10.1803 39.2L10.8803 42.14C11.2603 43.74 13.3003 44.24 14.3603 42.98L20.3403 36.1C20.8203 35.54 20.5603 34.66 19.8403 34.48C16.3003 33.62 13.1203 31.64 10.7803 28.82C10.4003 28.36 9.72033 28.3 9.30033 28.72L4.86033 33.16C3.34033 34.68 3.88033 36.58 5.40033 36.94Z" fill="#FBA935" />
    <path d="M24 4C16.26 4 10 10.26 10 18C10 20.9 10.86 23.56 12.34 25.78C14.5 28.98 17.92 31.24 21.9 31.82C22.58 31.94 23.28 32 24 32C24.72 32 25.42 31.94 26.1 31.82C30.08 31.24 33.5 28.98 35.66 25.78C37.14 23.56 38 20.9 38 18C38 10.26 31.74 4 24 4ZM30.12 17.56L28.46 19.22C28.18 19.5 28.02 20.04 28.12 20.44L28.6 22.5C28.98 24.12 28.12 24.76 26.68 23.9L24.68 22.72C24.32 22.5 23.72 22.5 23.36 22.72L21.36 23.9C19.92 24.74 19.06 24.12 19.44 22.5L19.92 20.44C20 20.06 19.86 19.5 19.58 19.22L17.88 17.56C16.9 16.58 17.22 15.6 18.58 15.38L20.72 15.02C21.08 14.96 21.5 14.64 21.66 14.32L22.84 11.96C23.48 10.68 24.52 10.68 25.16 11.96L26.34 14.32C26.5 14.64 26.92 14.96 27.3 15.02L29.44 15.38C30.78 15.6 31.1 16.58 30.12 17.56Z" fill="#FBA935" />
  </svg>,
  <svg key="e" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M32.38 4H15.62C8.34 4 4 8.34 4 15.62V32.36C4 39.66 8.34 44 15.62 44H32.36C39.64 44 43.98 39.66 43.98 32.38V15.62C44 8.34 39.66 4 32.38 4ZM21.9 35.02C21.32 35.6 20.22 36.16 19.42 36.28L14.5 36.98C14.32 37 14.14 37.02 13.96 37.02C13.14 37.02 12.38 36.74 11.84 36.2C11.18 35.54 10.9 34.58 11.06 33.52L11.76 28.6C11.88 27.78 12.42 26.7 13.02 26.12L21.94 17.2C22.1 17.62 22.26 18.04 22.48 18.52C22.68 18.94 22.9 19.38 23.14 19.78C23.34 20.12 23.56 20.44 23.74 20.68C23.96 21.02 24.22 21.34 24.38 21.52C24.48 21.66 24.56 21.76 24.6 21.8C25.1 22.4 25.68 22.96 26.18 23.38C26.32 23.52 26.4 23.6 26.44 23.62C26.74 23.86 27.04 24.1 27.3 24.28C27.62 24.52 27.94 24.74 28.28 24.92C28.68 25.16 29.12 25.38 29.56 25.6C30.02 25.8 30.44 25.98 30.86 26.12L21.9 35.02ZM34.74 22.18L32.9 24.04C32.78 24.16 32.62 24.22 32.46 24.22C32.4 24.22 32.32 24.22 32.28 24.2C28.22 23.04 24.98 19.8 23.82 15.74C23.76 15.52 23.82 15.28 23.98 15.14L25.84 13.28C28.88 10.24 31.78 10.3 34.76 13.28C36.28 14.8 37.02 16.26 37.02 17.78C37 19.22 36.26 20.66 34.74 22.18Z" fill="#47CDF2" />
  </svg>,
  <svg key="u" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M18 4C12.76 4 8.5 8.26 8.5 13.5C8.5 18.64 12.52 22.8 17.76 22.98C17.92 22.96 18.08 22.96 18.2 22.98C18.24 22.98 18.26 22.98 18.3 22.98C18.32 22.98 18.32 22.98 18.34 22.98C23.46 22.8 27.48 18.64 27.5 13.5C27.5 8.26 23.24 4 18 4Z" fill="#FFD335" />
    <path d="M28.1599 28.3C22.5799 24.58 13.4799 24.58 7.85992 28.3C5.31992 30 3.91992 32.3 3.91992 34.76C3.91992 37.22 5.31992 39.5 7.83992 41.18C10.6399 43.06 14.3199 44 17.9999 44C21.6799 44 25.3599 43.06 28.1599 41.18C30.6799 39.48 32.0799 37.2 32.0799 34.72C32.0599 32.26 30.6799 29.98 28.1599 28.3Z" fill="#FFD335" />
    <path d="M39.9807 14.68C40.3007 18.56 37.5407 21.96 33.7207 22.42C33.7007 22.42 33.7007 22.42 33.6807 22.42H33.6207C33.5007 22.42 33.3807 22.42 33.2807 22.46C31.3407 22.56 29.5607 21.94 28.2207 20.8C30.2807 18.96 31.4607 16.2 31.2207 13.2C31.0807 11.58 30.5207 10.1 29.6807 8.84002C30.4407 8.46002 31.3207 8.22002 32.2207 8.14002C36.1407 7.80002 39.6407 10.72 39.9807 14.68Z" fill="#FFD335" />
    <path d="M43.9805 33.18C43.8205 35.12 42.5805 36.8 40.5005 37.94C38.5005 39.04 35.9805 39.56 33.4805 39.5C34.9205 38.2 35.7605 36.58 35.9205 34.86C36.1205 32.38 34.9405 30 32.5805 28.1C31.2405 27.04 29.6805 26.2 27.9805 25.58C32.4005 24.3 37.9605 25.16 41.3805 27.92C43.2205 29.4 44.1605 31.26 43.9805 33.18Z" fill="#FFD335" />
  </svg>,
];

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17 17 7" />
    <path d="M8 7h9v9" />
  </svg>
);

export default function SloganSection({ props }) {
  const currentLanguage = getI18nLanguageFromLocalStorage();
  const [lang, setLang] = useState(null);
  const [t, setT] = useState({});

  // Init i18n + track current language (re-translate on language change)
  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => setLang(i18n.language));
    } else {
      setLang(i18n.language);
    }
  }, []);

  // i18n defaults — used only when the CMS field is empty (no hardcoded English in markup)
  useEffect(() => {
    let active = true;
    (async () => {
      const out = {};
      out.title = await translate("UMBRACO_LANDING.HOME.SLOGAN.TITLE", false, "New to DOTORE? Start here");
      out.subtitle = await translate("UMBRACO_LANDING.HOME.SLOGAN.SUBTITLE", false, "Three quick stops to figure out your level, how enrollment works, and which class fits you.");
      out.goal1Label = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL1_LABEL", false, "Take Level Test");
      out.goal1Sub = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL1_SUB", false, "~5 min · find your level");
      out.goal2Label = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL2_LABEL", false, "Enrollment & Manual");
      out.goal2Sub = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL2_SUB", false, "How to sign up & pay");
      out.goal3Label = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL3_LABEL", false, "Class Guide");
      out.goal3Sub = await translate("UMBRACO_LANDING.HOME.SLOGAN.GOAL3_SUB", false, "1:1 vs 1:N group");
      if (active) setT(out);
    })();
    return () => { active = false; };
  }, [lang]);

  // CMS first (Umbraco variant); i18n default when CMS empty
  const title = t.title || props?.title || "";
  const subtitle = t.subtitle || props?.subtitle || "";

  const i18nGoals = [
    { label: t.goal1Label, subtitle: t.goal1Sub, link: GOAL_LINKS[0] },
    { label: t.goal2Label, subtitle: t.goal2Sub, link: GOAL_LINKS[1] },
    { label: t.goal3Label, subtitle: t.goal3Sub, link: GOAL_LINKS[2] },
  ];

  const goals = i18nGoals;

  const renderTitle = (value) => {
    const str = String(value || "");
    const qIndex = str.indexOf("?");
    if (qIndex === -1) return str;
    const line1 = str.slice(0, qIndex + 1).trim();
    const line2 = str.slice(qIndex + 1).trim();
    if (!line2) return line1;
    return (
      <Fragment>
        {line1}
        {" "}
        <br className="quick-access__title-break" />
        {line2}
      </Fragment>
    );
  };

  // Language-aware: prefix the current language (e.g. /ko/courses?...). The /ko//en/
  // in the design URLs were just examples — the actual prefix follows the active language.
  const resolveLink = (link) => {
    const ln = currentLanguage || lang || "en";
    return link ? `/${ln}${link}` : `/${ln}`;
  };

  return (
    <section className="quick-access">
      <div className="quick-access__inner">
        <div className="quick-access__head">
          <h2 className="quick-access__title animate-on-scroll">{renderTitle(title)}</h2>
          {subtitle && <p className="quick-access__subtitle animate-on-scroll">{subtitle}</p>}
        </div>

        <div className="qa-cards">
          {goals.map((g, i) => (
            <a key={i} className="qa-card animate-on-scroll" href={resolveLink(g.link)}>
              <span className="qa-card__main">
                <span className="qa-card__icon">
                  {DEFAULT_ICONS[i % DEFAULT_ICONS.length]}
                </span>
                <span className="qa-card__text">
                  <span className="qa-card__title">{g.label}</span>
                  {g.subtitle && <span className="qa-card__sub">{g.subtitle}</span>}
                </span>
              </span>
              <span className="qa-card__arrow"><ArrowIcon /></span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
